import React, { useEffect, useMemo } from 'react';
import '../live/live.css';
import './output.css';
import { getRoomIdFromSearch } from '../shared/liveProtocol';
import { useRelayConnection } from '../live/useRelayConnection';
import PlaybackCanvas from '../live/PlaybackCanvas';

const OutputApp = () => {
  const roomId = useMemo(
    () => getRoomIdFromSearch(typeof window === 'undefined' ? '' : window.location.search),
    [],
  );
  const relay = useRelayConnection({ clientRole: 'output', roomId });

  useEffect(() => {
    const previousBodyBackground = document.body.style.background;
    const previousRootBackground = document.documentElement.style.background;
    document.body.style.background = 'transparent';
    document.documentElement.style.background = 'transparent';
    return () => {
      document.body.style.background = previousBodyBackground;
      document.documentElement.style.background = previousRootBackground;
    };
  }, []);

  useEffect(() => {
    if (roomId || process.env.NODE_ENV === 'production') return;
    // Keep the browser source blank, but surface the problem during development.
    console.warn('[LowerThirds] Output mode opened without a room id.');
  }, [roomId]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' || !relay.connectionError) return;
    console.warn('[LowerThirds] Output relay connection failed.', relay.connectionError);
  }, [relay.connectionError]);

  return (
    <div className="output-root">
      <PlaybackCanvas
        className="output-canvas-shell"
        liveProgram={roomId ? relay.live.program : null}
        livePhase={roomId ? relay.live.phase : 'idle'}
        playbackStartedAt={roomId ? relay.live.playbackStartedAt : null}
        playbackElapsedMs={roomId ? relay.live.playbackElapsedMs : 0}
        serverClockOffsetMs={roomId ? relay.serverClockOffsetMs : 0}
        forceTransparentBackground
      />
    </div>
  );
};

export default OutputApp;
